import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";
import { data } from 'jquery';

const SiteIncentiveList = ({
    getAllIncentives,
    incentives,
    history,
    match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [remark, setRemark] = useState("");
  const [closed, setClosed] = useState(false);
  const [roleId, setRoleId] = useState();

  const handleModalHide = () => {
    setIsModal(false);
    window.location.reload();
  }
  
  useEffect(() => {
    if (getAllIncentives !== null){
        (async () => {
            setIsLoading(true);
            await getAllIncentives(1,1);
            setIsLoading(false);
          })();
    }
  },[getAllIncentives]);

  useEffect(() => {
    if (closed === true){
        window.location.reload();
    }
  },[closed]);

  useEffect(() => {
    (async () => {
      const role =
        (await JSON.parse(localStorage.getItem('roles'))) &&
        JSON.parse(localStorage.getItem('roles'))[0].id;
      setRoleId([role]);
    })();
  }, []);

  const headers_sm = [
    'Site',
    'Incentive For',
    'Incentive Amount',
    'User',
    'User Incentive(%)',
    'User Incentive Amount',
    'User Payment Status'
  ];
  const headers_zm = [
    'Site',
    'Incentive For',
    'Incentive Amount',
    'User',
    'User Incentive(%)',
    'User Incentive Amount',
    'User Payment Status',
    'Senior',
    'Senior Incentive(%)',
    'Senior Incentive Amount',
    'Senior Payment Status'
  ];
  const headers = [
    'Site',
    'Incentive For', 
    'Incentive Amount', 
    'User',
    'User Incentive(%)',
    'User Incentive Amount',
    'User Payment Status',
    'Senior',
    'Senior Incentive(%)',
    'Senior Incentive Amount',
    'Senior Payment Status',
    'Head',
    'Head Incentive(%)',
    'Head Incentive Amount',
    'Head Payment Status'
  ];

  useEffect(() => {
    var tableData =[];
    console.log(roleId);
    if (roleId == 7) {
      tableData = [
        'id',
        'site_name',
        'incentive_for',
        'incentive_amount',
        'user_name',
        'user_incentive_percentage',
        'user_incentive',
        'user_utr_no'
      ];
    } else if(roleId == 6) {
      tableData = [
        'id',
        'site_name',
        'incentive_for',
        'incentive_amount',
        'user_name',
        'user_incentive_percentage',
        'user_incentive',
        'user_utr_no',
        'senior_name',
        'senior_incentive_percentage',
        'senior_incentive',
        'senior_utr_no'
      ];
    } else if(roleId == 5){
      tableData = [
        'id',
        'site_name',
        'incentive_for',
        'incentive_amount',
        'user_name',
        'user_incentive_percentage',
        'user_incentive',
        'user_utr_no',
        'senior_name',
        'senior_incentive_percentage',
        'senior_incentive',
        'senior_utr_no',
        'head_name',
        'head_incentive_percentage',
        'head_incentive',
        'head_utr_no'
      ];
    }

    if (roleId !== '') {
      if (incentives && incentives?.data && incentives?.data.length > 0) {
          const data = incentives.data.map((element) =>
              Object.assign(
                  {},
                  ...tableData.map((key) => (
                      (key === 'sales_status' && element['sales_status'] === 1) ?
                      {[key]: 'Approved'} : (key === 'sales_status' && element['sales_status'] === 2) ?
                      {[key]: 'Rejected'} : (key === 'sales_status' && element['sales_status'] === 0) ?
                      {[key]: 'Pending'} : (key === 'finance_status' && element['finance_status'] === 0) ?
                      {[key]: 'Pending'} : (key === 'finance_status' && element['finance_status'] === 1) ?
                      {[key]: 'Approved'} : (key === 'finance_status' && element['finance_status'] === 2) ?
                      {[key]: 'Rejected'} : (key === 'finance_status' && element['finance_status'] === 3) ?
                      {[key]: 'Hold'} : (key === 'user_name' && element['user_name'] === null) ?
                      {[key]: 'NA'} : (key === 'senior_name' && element['senior_name'] === null) ?
                      {[key]: 'NA'} : (key === 'head_name' && element['head_name'] === null) ?
                      {[key]: 'NA'} : (key === 'user_utr_no' && element['user_utr_no'] === null && element['user_name'] === null) ?
                      {[key]: 'NA'} : (key === 'user_utr_no' && element['user_utr_no'] === null && element['user_name'] !== null) ?
                      {[key]: 'Unpaid'} : (key === 'user_utr_no' && element['user_utr_no'] !== null && element['user_name'] !== null) ?
                      {[key]: 'Paid'} : (key === 'senior_utr_no' && element['senior_utr_no'] === null && element['senior_name'] === null) ?
                      {[key]: 'NA'} : (key === 'senior_utr_no' && element['senior_utr_no'] === null && element['senior_name'] !== null) ?
                      {[key]: 'Unpaid'} : (key === 'senior_utr_no' && element['senior_utr_no'] !== null && element['senior_name'] !== null) ?
                      {[key]: 'Paid'} : (key === 'head_utr_no' && element['head_utr_no'] === null && element['head_name'] === null) ?
                      {[key]: 'NA'} : (key === 'head_utr_no' && element['head_utr_no'] === null && element['head_name'] !== null) ?
                      {[key]: 'Unpaid'} : (key === 'head_utr_no' && element['head_utr_no'] !== null && element['head_name'] !== null) ?
                      {[key]: 'Paid'} : (key === 'created_by_user' && element['created_by_user'] === null) ?
                      {[key]: 'Auto'} : (key === 'site_name' && element['site_no'] !== null) ?
                      {[key]: element['site_name']+'('+element['site_no']+')'} : (key === 'Approve/Reject' &&(element['sales_status'] === 1 || element['sales_status'] === 2)) ?
                      {[key]: 'No'} : {[key]: element[key]}
                      )
                  )
              )
          );
          data && setListData(data);
          setPageCount(Math.ceil(incentives.total / incentives.per_page));
      }

    }
  }, [incentives]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getAllIncentives(val.selected + 1, 1);
    setIsLoading(false);
  };


  return (
    <Layout
      title={localization.incentiveList}
      // Buttons={headerBtns}
      isLoading={isLoading}
    >

    <div className="container-fluid">
      <div className="card mt-2">
        <div className="card-header">
          {localization.incentiveList}
        </div>
          <div className="card-header">
           <div className="card-body">
            <TableSection
              data={listData}
              isId={false}
              isMngId={false}
              headers={(roleId == 7) ? headers_sm : (roleId == 6) ? headers_zm : headers}
              pageCount={pageCount}
              onPageChange={onPageChange}
              srNo={incentives?.data?.from}
            />
           </div>
          </div>
        </div>
      </div>

     
    </Layout>
  );
};

export default SiteIncentiveList;
